// Copyright © 2024 650 Industries.

'use client';

import { View } from 'react-native';

import type { GlassContainerProps } from './GlassContainer.types';

export default function GlassContainer(props: GlassContainerProps) {
  return <View {...props} />;
}
